import React from 'react';
import {Dropdown} from '@deere/ux.uxframe-react';
import styles from './index.css';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import {CONTRATO_STRING} from '../Constants/constants';

export const DocumentDownloadDropdown = ({disabled, documentsInEnvelope, documentType, dropdownHandler, envelopeId}) => {
    const envelopeContainsContratoDocument = documentsInEnvelope.some(document => document && document.documentDesc && document.documentDesc.toUpperCase() === CONTRATO_STRING);

    return(
        <Dropdown className={styles.dropdownMenuDiv}>
            <Dropdown.Toggle className={styles.dropdownFeature} disabled={disabled} id="dropdown-basic" variant="secondary">
                <FormattedMessage id={`labels.${documentType}`}/>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item
                    inline={true}
                    key={`pdf-${envelopeId}`}
                    onSelect={() => dropdownHandler('COMBINED')}
                    value={'COMBINED'}
                >
                    <FormattedMessage id={'labels.COMBINED'}/>
                </Dropdown.Item>
                <Dropdown.Item
                    key={`zip-${envelopeId}`}
                    onSelect={() => dropdownHandler('SEPARATE')}
                    value={'SEPARATE'}
                >
                    <FormattedMessage id={'labels.SEPARATE'}/>
                </Dropdown.Item>
                <Dropdown.Item
                    disabled={!envelopeContainsContratoDocument}
                    key={`eregistry-${envelopeId}`}
                    onSelect={() => dropdownHandler('E-REGISTRY_DOWNLOAD')}
                    value={'E-REGISTRY_DOWNLOAD'}
                >
                    <FormattedMessage id={'labels.E-REGISTRY_DOWNLOAD'}/>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>)
}
DocumentDownloadDropdown.propTypes = {
    disabled: PropTypes.bool.isRequired,
    documentsInEnvelope: PropTypes.array.isRequired,
    documentType: PropTypes.string.isRequired,
    dropdownHandler: PropTypes.func.isRequired,
    envelopeId: PropTypes.string.isRequired
}
